import { memo as J, useMemo as A } from "react";
import { Box3 as K, Vector3 as f } from "three";
import { getRgMesh as C } from "../../../3d/rg-render-types/index3.js";
import { getHorizontalArea as L } from "../../../metrics/object-helpers/index2.js";
import { jsx as i, Fragment as B, jsxs as u } from "react/jsx-runtime";
const p = new K(), n = new f(), o = new f(), c = new f(), Y = J(function H({
  view: r,
  show: m,
  camForward: T,
  filter: h,
  style: t,
  bypassColor: a = "",
  recursive: g
}) {
  var k, S, F, D, O, j, M, z, b, W, w;
  const e = r.userData, q = Object.keys(t);
  if (h && !h(e))
    return /* @__PURE__ */ i(B, {});
  const y = ((k = t[e.type]) == null ? void 0 : k.textOnly) || !1, x = {
    fill: ((S = t[e.type]) == null ? void 0 : S.color) || e.color,
    fillOpacity: ((F = t[e.type]) == null ? void 0 : F.fillOpacity) || 1,
    stroke: ((D = t[e.type]) == null ? void 0 : D.strokeColor) || "black",
    strokeWidth: ((O = t[e.type]) == null ? void 0 : O.strokeWidth) || 0.01
  };
  !a && q.flat().includes(e.type) && (a = t[e.type] ? x.fill : ""), e.type === "Facade" && (a = "#F2F3F5");
  const E = {
    fill: ((j = t[e.type]) == null ? void 0 : j.color) || e.color,
    stroke: ((M = t[e.type]) == null ? void 0 : M.secondaryStrokeColor) || "black",
    strokeWidth: ((z = t[e.type]) == null ? void 0 : z.secondaryStrokeWidth) || 0.01
  };
  e.type === "Opening" && (x.fill = a, x.stroke = ((b = r == null ? void 0 : r.parent) == null ? void 0 : b.userData.type) === "Facade" ? (W = t[e.type]) == null ? void 0 : W.strokeColor : a);
  const G = A(() => {
    const d = C(r);
    return p.setFromObject(d, !0), p.getCenter(n), p.getSize(o), c.copy(n).sub(o.clone().multiplyScalar(0.5)), {
      width: o.x,
      height: o.y,
      x: c.x,
      y: c.y
    };
  }, [r, t]), I = A(() => {
    var l, s, R, V, $;
    if (!((l = t[r.userData.type]) != null && l.secondaryStrokeColor))
      return;
    const d = C(r);
    return p.setFromObject(d, !0), p.getCenter(n), p.getSize(o), c.copy(n).sub(o.clone().multiplyScalar(0.5)), {
      width: o.x > o.y ? o.x : o.x / (((s = t[e.type]) == null ? void 0 : s.drawDimMod) || 1),
      height: o.x < o.y ? o.y : o.y / (((R = t[e.type]) == null ? void 0 : R.drawDimMod) || 1),
      x: o.x > o.y ? c.x : c.x + (o.x / (((V = t[e.type]) == null ? void 0 : V.drawDimMod) * 2 || 1) || 0),
      y: o.x < o.y ? c.y : c.y + (o.y / ((($ = t[e.type]) == null ? void 0 : $.drawDimMod) * 2 || 1) || 0)
    };
  }, [r, t]);
  return /* @__PURE__ */ u(B, {
    children: [!y && m.includes(e.type) && /* @__PURE__ */ i("rect", {
      name: `${e.name}-view`,
      ...G,
      style: x
    }), !y && ((w = t[e.type]) == null ? void 0 : w.secondaryStrokeColor) && m.includes(e.type) && /* @__PURE__ */ i("g", {
      children: /* @__PURE__ */ i("rect", {
        name: `${e.name}-component-view`,
        ...I,
        style: E
      })
    }), !y && g && e.children.map((d, l) => /* @__PURE__ */ i(H, {
      show: m,
      camForward: T,
      view: r.children.find((s) => s.userData === d),
      filter: h,
      style: t,
      bypassColor: a,
      recursive: g
    }, l)), y && m.includes(e.type) && /* @__PURE__ */ i("g", {
      children: /* @__PURE__ */ u("text", {
        name: `${e.name}-room-text`,
        x: n.x,
        y: n.y,
        fontSize: "1.2%",
        textAnchor: "middle",
        style: {
          whiteSpace: "pre-line"
        },
        children: [/* @__PURE__ */ i("tspan", {
          x: n.x,
          dy: "0em",
          children: e.name
        }), /* @__PURE__ */ u("tspan", {
          x: n.x,
          dy: "1.2em",
          children: [+L(e).toFixed(1), "m2"]
        })]
      })
    })]
  });
});
export {
  Y as SvgRgView
};
//# sourceMappingURL=index.js.map
